import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Build a BreadcrumbList schema for a given path. */
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}

/**
 * SEO + GEO structured-data manager.
 * `schemas` can be a single object or an array (page schema, breadcrumb, etc.).
 * Static site-wide schema (Organization, WebSite, Person, LocalBusiness x2) is baked
 * into public/index.html so crawlers see it without JS.
 */
export default function Seo({ title, description, path = "/", schemas }) {
  useEffect(() => {
    const base = "https://entspecialistvaranasi.com";
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", base + path);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(base + path);

    // Remove any prior page-scoped JSON-LD (leave static site-wide one alone).
    document.head
      .querySelectorAll('script[data-page-jsonld="true"]')
      .forEach((n) => n.remove());

    const list = Array.isArray(schemas) ? schemas : schemas ? [schemas] : [];
    list.forEach((schema) => {
      if (!schema) return;
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
    window.scrollTo(0, 0);

    return () => {
      document.head
        .querySelectorAll('script[data-page-jsonld="true"]')
        .forEach((n) => n.remove());
    };
  }, [title, description, path, schemas]);

  return null;
}
